import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const indexSettlementGroupsRequest = ({ dispatch, params = {}, successCallback, callback }) =>
  ApiService.request('get', '/settlement_groups', {
    dispatch,
    params,
    successCallback,
    callback,
    service: 'payroll'
  });

export const createSettlementGroupRequest = ({ dispatch, params, formData, successCallback, callback }) =>
  ApiService.request('post', '/settlement_groups', {
    dispatch,
    params,
    formData,
    successCallback,
    callback,
    service: 'payroll'
  });

export const showSettlementGroupRequest = (id, { dispatch, params = {}, successCallback, callback }) =>
  ApiService.request('get', `/settlement_groups/${id}`, {
    dispatch,
    params,
    successCallback,
    callback,
    service: 'payroll'
  });

export const updateSettlementGroupRequest = (id, { dispatch, params, formData, successCallback, callback }) =>
  ApiService.request('put', `/settlement_groups/${id}`, {
    dispatch,
    params,
    formData,
    successCallback,
    callback,
    service: 'payroll'
  });

export const deleteSettlementGroupRequest = (id, { dispatch, successCallback, callback, failureCallback }) =>
  ApiService.request('delete', `/settlement_groups/${id}`, {
    dispatch,
    successCallback,
    failureCallback,
    callback,
    service: 'payroll'
  });

export const generateSettlementGroupDocument = (groupId, { dispatch, params, formData, successCallback, callback }) =>
  ApiService.request('post', `/settlement_groups/${groupId}/generate_group_documents`, {
    dispatch,
    params,
    formData,
    successCallback,
    callback,
    service: 'payroll'
  });

export const massiveDestroySettlementGroupRequest = ({ dispatch, params, successCallback, callback }) =>
  ApiService.request('delete', '/settlement_groups/massive_destroy', {
    dispatch,
    params,
    successCallback,
    callback,
    service: 'payroll'
  });

export const exportSettlementGroupRequest = ({ dispatch, params, successCallback, callback, format }) =>
  ApiService.request('get', `/settlement_groups/export${format}`, {
    dispatch,
    params,
    successCallback,
    callback,
    service: 'payroll'
  });

export const debounceIndexSettlementsRequest = AwesomeDebouncePromise(indexSettlementGroupsRequest, 300);
